export const Sections = {
  MEDIA_TRACKING: 'media_tracking',
  PERFORMANCE: 'performance',
  SPONSORSHIP_VALUATION: 'sponsorship_valuation',
};
